import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Api from "../../services/Api";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        rol: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.rol;
        state[e.target.name] = e.target.value;
        this.setState({ rol: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const nombre = document.getElementById('nombre').value;
        const descripcion = document.getElementById('descripcion').value;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!descripcion) { errores.push("error_descripcion"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        authAxios.post("roles/update", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.fire(
                    'Roles!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterRoles");
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("roles/detail/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, rol: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, rol } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR ROL</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-3">
                                                    <input type="hidden" name="id" value={this.props.match.params.id} />
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={rol.nombre}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "border border-info") + " form-control form-control-sm"} placeholder="NOMBRE" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                                <div className="col-md-9">
                                                    <label htmlFor="descripcion">Descripción</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" id="descripcion" name="descripcion" defaultValue={rol.descripcion}
                                                        className={((this.verificarError("error_descripcion")) ? "is-invalid" : "border border-info") + ' form-control form-control-sm'} placeholder="DESCRIPCIÓN" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite la Descripción</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Rol</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterRoles"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;